"use client";
import { useMoveToWishlist } from "@repo/lib/hooks/catalog";
import { LoadingDots } from "@repo/ui";
import cx from "classnames";

const MoveToWishlistButton = ({ item, miniCart }) => {
  const { handleMoveItemToWishlist, isPending, t } = useMoveToWishlist(item);

  return (
    <button
      onClick={() => handleMoveItemToWishlist(item?.id)}
      className="min-w-[142px]"
    >
      {isPending ? (
        <LoadingDots className="bg-black" />
      ) : (
        <span
          className={cx(
            "border-miniCart-border text-miniCart-link me-5 block border-e pe-5 text-start text-sm font-medium hover:underline",
            {
              "rtl:me-2 rtl:w-[90%] rtl:pe-0 rtl:md:me-5 rtl:md:w-auto rtl:md:pe-5":
                !miniCart,
              "rtl:w-[90%] rtl:md:me-2 rtl:md:pe-0": miniCart,
            }
          )}
        >
          {t("Move_To_Wishlist")}
        </span>
      )}
    </button>
  );
};

export default MoveToWishlistButton;
